
import styled from "styled-components";

const StyleWrapper = styled.div`
flex: 1 1 0px;

  .card_wrapper{
    display: flex;
    padding: 1rem;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0.75rem;
    align-self: stretch;
    border-radius: 0.75rem;
    background: var(--White, #FFF);
    &.active{
        background: var(--primary-primary-color, #6B47F5);
        .product_name,
        .price_wrapper *,
        .product_description {
            color: var(--White, #FFF) !important;
        }
        .product_description, .sar, .vat{
            opacity: 0.8;
        }
    }
    .product_name{
        color: var(--text-black, #1A1C1F);
        /* Heading En/Heading Tiny */
        font-family: Tawuniya;
        font-size: 0.875rem;
        font-style: normal;
        font-weight: 700;
        line-height: 130%; /* 1.1375rem */
        letter-spacing: -0.0175rem;
        margin: 0;
    }
    .product_description{
        color: var(--text-dark-gray, #455560);
        align-self: stretch;
        /* Paragraph En/XS Paragraph */
        font-family: Tawuniya;
        font-size: 0.75rem;
        font-style: normal;
        font-weight: 400;
        line-height: 160%; /* 1.2rem */
    }
    .price_wrapper{
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        align-self: stretch;
        .price{
            color: var(--primary-primary-color, #6B47F5);
            font-family: Tawuniya;
            font-size: 1.125rem;
            font-style: normal;
            font-weight: 700;
            line-height: 1.125rem; /* 100% */
            letter-spacing: -0.03375rem;
        }
        .sar{
            color: var(--text-dark-gray, #455560);
            /* Label En/XSS Label */
            font-family: Tawuniya;
            font-size: 0.625rem;
            font-style: normal;
            font-weight: 400;
            line-height: 0.625rem; /* 100% */
        }
        .vat{
            color: var(--text-dark-gray, #455560);
            font-family: Tawuniya;
            font-size: 0.5rem;
            font-style: normal;
            font-weight: 400;
            line-height: 0.5rem; /* 100% */            
        }
    }

  }

  /* -------------------------- Prime Cust --------------------------*/
  .p-radiobutton .p-radiobutton-box{
      background: var(--neutral-light, #F2F3F5);
      border: 0;
  }
  .p-radiobutton .p-radiobutton-box.p-highlight{
      border-color: var(--White, #FFF) !important;
      background: var(--White, #FFF) !important;
  }
  .p-radiobutton .p-radiobutton-box .p-radiobutton-icon{
    width: 0.57rem;
    height: 0.57rem;
    flex-shrink: 0;
    background-color: var(--text-black, #1A1C1F);
  }
`;

export default StyleWrapper;
